import React from 'react';
import { Box, Container } from '@radix-ui/themes';
import { WordInfo } from '../types';
import { JapaneseDisplay } from './JapaneseDisplay';

interface ResultProps {
  words: WordInfo[];
  traditionalText: string;
  originalText: string;
  showTraditional: boolean;
  onWordClick?: (word: WordInfo, element: HTMLElement, wordKey: string) => void;
  selectedWordKeys?: Set<string>;
}

export const Result: React.FC<ResultProps> = ({
  words,
  traditionalText,
  originalText,
  showTraditional,
  onWordClick,
  selectedWordKeys
}) => {
  const displayWords = words
    .filter(Boolean)
    .filter(word => !word.error && word.text.trim().length > 0);
  const displayText = showTraditional && traditionalText ? traditionalText : originalText;

  return (
    <Container size="3">
      {displayWords.length > 0 && (
        <Box mb="4">
          <JapaneseDisplay
            words={displayWords}
            translatedText={displayText}
            onWordClick={onWordClick}
            selectedWordKeys={selectedWordKeys}
          />
        </Box>
      )}
    </Container>
  );
};